import { Box, Card, CardContent, Modal, Typography } from '@mui/material';
import React from 'react';
import strings from '../../Globalization/index';

export const Loading = ({ title, color }) => (
	<Box
		sx={{
			display: 'flex',
			flexDirection: 'column',
			justifyContent: 'center',
			alignItems: 'center',
			gap: theme => theme.spacing(),
			padding: '10px',
			'& .lds-facebook': {
				'& div': {
					backgroundColor: color || 'rgb(47, 64, 80)'
				}
			}
		}}
	>
		<Box className="lds-facebook">
			<div />
			<div />
			<div />
			<div />
			<div />
		</Box>
		{title && (
			<Typography variant="body1" className="loader-text">
				{title}
			</Typography>
		)}
	</Box>
);
const LoadingDialog = ({ message, open, isOpen, color, className, ...rest }) => (
	<Modal
		open={Boolean(open || isOpen)}
		disableEscapeKeyDown={true}
		className={`wrapper print-hide ${className || ""}`}
		data-html2canvas-ignore="true"
		sx={{
			zIndex: (theme) => theme.zIndex.tooltip,
			'& .loadingContentWrapper': {
				position: 'absolute',
				top: '50%',
				left: '50%',
				transform: 'translate(-50%, -50%)',

				width: 200,
				'& .MuiCardContent-root': {
					padding: 0
				}
			}
		}}
		{...rest}
	>
		<Card elevation={8} className="loadingContentWrapper">
			<CardContent>
				<Loading
					title={message ? strings[message] || message : strings.DefaultWaitingMsg || 'Loading...'}
					color={color}
				/>
			</CardContent>
		</Card>
	</Modal>
);

export default LoadingDialog;
